import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { setLoading } from '../../../store/slices/UI';

export const initCollaborator = {
  initVisible: false,

  isCloseVisible: true
};

const { initVisible } = initCollaborator;

const useCollaborator = () => {
  const [visible, setVisible] = useState(initVisible);
  const [isCloseVisible, setIsCloseVisible] = useState(initVisible);

  // Redux
  const dispatch = useDispatch();

  const showAddCollaborator = useCallback(
    (isCloseVisible = true) => {
      dispatch(setLoading(false));
      setVisible(true);
      setIsCloseVisible(isCloseVisible);
    },
    [dispatch]
  );

  const hideAddCollaborator = useCallback(() => {
    setVisible(false);
  }, []);

  return {
    visible: visible,
    showAddCollaborator: showAddCollaborator,
    hideAddCollaborator: hideAddCollaborator,
    isCloseVisible
  };
};

export default useCollaborator;
